<div class="magic-wrap">
    <div class="top-row">
        <div class="top-text">
<!--            <div>{{ 'organizationId' | translate}}</div>-->
            <div class="title">{{ 'generateMagicLink' | translate}}</div>
            <div class="subtitle">
                {{ 'magicLinkDescription' | translate}}
            </div>
        </div>

        <div class="action">
            <button
                    class="btn-generate"
                    (click)="generate()"
                    [disabled]="isGenerating || !evaluationId"
                    title="{{ 'magicLinkButtonText' | translate }}"
            >
                <span *ngIf="!isGenerating">{{ 'magicLinkButtonText' | translate }}</span>
                <span *ngIf="isGenerating">{{ 'magicLinkButtonGeneration' | translate }}</span>
            </button>
        </div>
    </div>

    <div class="bottom-row" *ngIf="generatedUrl">
        <div class="url-box" tabindex="0" (click)="copyToClipboard()">
            <div class="url-text" title="{{ generatedUrl }}">{{ generatedUrl }}</div>
            <button class="copy-btn" (click)="copyToClipboard(); $event.stopPropagation()" title="{{ 'magicLinkCopyLink' | translate}}">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M16 1H4C2.9 1 2 1.9 2 3V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <rect x="8" y="5" width="13" height="13" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
        <div class="copy-hint">
            <span *ngIf="!copied">{{'magicLinkClickToCopy' | translate}}</span>
            <span *ngIf="copied">{{'magicLinkCopied' | translate}}</span>
        </div>
    </div>

    <div class="error" *ngIf="error">{{ error }}</div>
    <div class="no-eval" *ngIf="!evaluationId">{{'magicLinkError' | translate}}</div>
</div>
